import React from 'react';
import { Button } from './ui/button';
import { Sparkles } from 'lucide-react';

const AutoLoadSection = () => {
  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h2 className="text-4xl lg:text-5xl font-bold leading-tight">
              <span className="text-gray-900">Auto-Load Matching</span>
              <br />
              <span className="bg-gradient-to-r from-purple-600 to-purple-500 bg-clip-text text-transparent">With AI</span>
            </h2>
            
            <p className="text-gray-600 text-lg leading-relaxed">
              Automatically recommend the best loads based on location, rate, and
              your driver preferences.
            </p>
            
            <Button 
              className="bg-gradient-to-r from-purple-600 to-purple-500 hover:from-purple-700 hover:to-purple-600 text-white px-8 py-6 rounded-full text-base font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              Free Demo
            </Button>
          </div>
          
          <div className="relative">
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-12 rounded-3xl">
              <Sparkles className="w-24 h-24 text-purple-600 mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutoLoadSection;
